import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectTimesheetValue } from '../../../../../../../../../../services/timesheets/selectors';

interface Props {
    entityName?: ?string;
}

export class TimesheetEntityName extends React.PureComponent<Props> {
    render() {
        const { entityName } = this.props;
        if (!entityName) return null;
        return entityName;
    }
}

const mapStateToProps = createStructuredSelector({
    entityName: makeSelectTimesheetValue('entityName')
});

export default connect(mapStateToProps)(TimesheetEntityName);
